// Copyright (c) 2020 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const PartCoverageSearchButtonGroup = props =>
    <div className='parts-coverage-search-criteria-footer'>
        <div className='asterisk-before'>
            <FormattedMessage id='INDICATES_REQUIRED_FIELD'/>
        </div>
        <div className='button-group'>
            <button
                className='secondary-button'
                onClick={props.onCriteriaReset}
                type='submit'
            >
                <FormattedMessage id='RESET'/>
            </button>
            <button
                className='primary-button'
                disabled={!props.canRunReport}
                onClick={props.onPartSearchExecute}
                type='submit'
            >
                <FormattedMessage id='EXECUTE'/>
            </button>
        </div>
    </div>;

PartCoverageSearchButtonGroup.displayName = 'PartCoverageSearchButtonGroup';
PartCoverageSearchButtonGroup.propTypes = {
    canRunReport: PropTypes.bool.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onPartSearchExecute: PropTypes.func.isRequired
};

export default PartCoverageSearchButtonGroup;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/components/parts-coverage-search-criteria-footer.js